import { motion } from 'framer-motion';

import Card from '../../components/Card';
import BackButton from '../../components/BackButton/BackButton';
import { titleSection, cardInOut } from '../../animations/PageAnimations';

import Iphone from "../../assets/images/iphone.png";
import { useAppSelector } from '../../hooks';
import { selectSectionById } from '../../store/WebSettingsSlice';

const Accounts = () => {

  const ID_SECTION = 'accounts';
  const section = useAppSelector(state => selectSectionById(state, ID_SECTION));

  return (
    <section className="mx-auto px-12 pt-8">
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        key="title-accounts"
        variants={titleSection}
      >
        <BackButton />
        <h1 className="mt-4 xl:mt-6 font-bold"
          dangerouslySetInnerHTML={{__html:section?.title || ''}}/>
      </motion.div>

      <motion.div className="mt-6 xl:mt-8 flex flex-row"
        key="content-accounts"
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <div className="cards-icons-top grid grid-cols-2 gap-4 xl:gap-8  w-2/3">

          { section?.cards?.map((cardData, index) => {
            const card = cardData;
            return (
              <Card
                {...card}
                index={index + 1}
                key={card.id}
              />
            );
          })}

        </div>

        <motion.div
          key="bancamovil"
          custom="5"
          initial="initial"
          animate="animate"
          exit="exit"
          variants={cardInOut}
          className="relative rounded-2xl bg-gray ml-8 w-1/3 py-12 px-4 text-center flex flex-col items-center">
          <h2 className="text-2xl">Maneja tus cuentas <br />con tu celular.</h2>
          <h2 className="mt-2 text-3xl">Descarga Banca Móvil.</h2>
          <img className="select-none bg-white z-20 absolute bottom-32 w-40" src={`${process.env.PUBLIC_URL}/images/qrcode-download-app.png`} alt="" />
          <p className="absolute bottom-8 z-10">Escanea el código QR</p>
          <img className="select-none absolute bottom-0 z-0" src={Iphone} alt="Phone" />

        </motion.div>
      </motion.div>
    </section>
  );
};
export default Accounts;
